var _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWriting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_470_2284)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 48,
    height: 48,
    rx: 10,
    fill: "url(#paint0_linear_470_2284)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_470_2284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13086 11.7218C10.6961 9.63485 12.783 5.46094 21.6513 5.46094C29.094 5.46094 33.7331 5.46094 39.3276 5.46094C44.9222 5.46094 49.4091 8.41746 50.9743 11.7218",
    stroke: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_470_2284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 40.0001C36.6275 40.0001 42.0001 34.6275 42.0001 28C42.0001 21.3726 36.6275 16 30 16C23.3726 16 18 21.3726 18 28C18 34.6275 23.3726 40.0001 30 40.0001Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5375 31.5236L36.3828 21.9236C36.3676 21.7585 36.2055 21.5967 36.0559 21.5967L26.4563 24.4424C26.3627 24.4424 26.018 24.7522 25.9693 24.8247C25.8971 24.8733 23.2695 30.8202 23.2695 30.8202C23.2695 30.9697 26.9774 34.6772 27.1265 34.6772C27.1265 34.6772 33.1072 32.0833 33.1555 32.0107C33.2283 31.9623 33.5375 31.6172 33.5375 31.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2755 21.7039C36.2267 21.6554 36.1386 21.6045 36.0561 21.5967L26.4563 24.4422C26.3627 24.4422 26.018 24.752 25.9693 24.8245C25.8971 24.8731 23.2695 30.82 23.2695 30.82C23.2695 30.8926 24.2329 31.8932 25.1528 32.8147L36.2755 21.7039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6795 35.0113L24.8176 33.1494L21.498 36.4692C22.1984 37.1724 22.9863 37.7882 23.8425 38.3011L26.6791 35.4647C26.8045 35.3393 26.8045 35.1366 26.6795 35.0113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8182 33.1497L22.9521 31.2842L24.8182 33.1497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8177 33.1492L22.9517 31.2835C22.8266 31.1581 22.6239 31.1581 22.4986 31.2835L19.6719 34.1103C20.1823 34.9715 20.7959 35.7639 21.4981 36.4688L24.8177 33.1492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6427 29.9582C28.5919 30.0085 28.3107 29.8079 28.244 29.741C28.1769 29.6747 27.9765 29.3928 28.0265 29.3427L36.1672 21.5762C36.218 21.5261 36.3128 21.5396 36.3793 21.6057C36.446 21.6728 36.4592 21.7675 36.4088 21.8178L28.6427 29.9582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8122 30.3401C28.4236 30.7295 27.8492 30.7858 27.5301 30.4667C27.211 30.1472 27.2673 29.5733 27.6559 29.1843C28.0453 28.7956 28.6189 28.7393 28.938 29.0584C29.2572 29.3771 29.2011 29.9515 28.8122 30.3401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.694 30.2212C28.3846 30.5314 27.9276 30.5758 27.6732 30.3215C27.4193 30.0679 27.4645 29.6109 27.7739 29.3011C28.0837 28.9913 28.5407 28.947 28.7946 29.2009C29.0485 29.4548 29.0038 29.9118 28.694 30.2212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4304 21.6918C36.4304 21.6918 36.4172 21.6433 36.3791 21.6049C36.341 21.5668 36.2921 21.5537 36.2921 21.5537L28.1853 29.4815C28.1345 29.5319 28.2149 29.6928 28.2529 29.7309C28.291 29.7693 28.4525 29.8493 28.5027 29.7989L36.4304 21.6918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3791 21.6049C36.341 21.5668 36.2921 21.5537 36.2921 21.5537L28.5991 29.0768C28.3444 28.9809 28.0147 29.0609 27.7739 29.3015C27.4645 29.6113 27.4193 30.0684 27.6732 30.3219L36.3791 21.6049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1415 35.3951C27.0045 35.5325 26.7824 35.5325 26.6456 35.3955L22.5679 31.3178C22.4305 31.1804 22.4305 30.9585 22.5679 30.8215L22.8432 30.5458C22.9802 30.4092 23.2023 30.4092 23.3391 30.5458L27.4168 34.6237C27.5542 34.7607 27.5542 34.9828 27.4168 35.1195L27.1415 35.3951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6086 33.3585L22.5679 31.3178C22.4305 31.1804 22.4305 30.9585 22.5679 30.8215L22.8432 30.5458C22.9802 30.4092 23.2023 30.4092 23.3391 30.5458L25.38 32.5867L24.6086 33.3585Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_470_2284",
    x: 0,
    y: 2,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_470_2284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_470_2284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_470_2284",
    x: 4.73047,
    y: 0.960938,
    width: 50.6953,
    height: 15.0605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_470_2284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_470_2284",
    x1: 30,
    y1: 4,
    x2: 30,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.173913,
    stopColor: "#6775F8",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6775F8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_470_2284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(18 16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriting);
export default __webpack_public_path__ + "static/media/writing.d5fc5064e971d67cbc9b8d1f707ba9d0.svg";
export { ForwardRef as ReactComponent };